<script>
	connect();
	let midiIn = [];
  let midiOut = [];
	let receivedMessages = []
  let sentMessages = []

  let selectedDeviceId
  let selectedType
  let selectedChannel = 0
  let selectedId = 0
  let selectedValue = 0


// Start up WebMidi.
function connect() {
  navigator.requestMIDIAccess()
  .then(
    (midi) => onReady(midi),
    (err) => console.log('Something went wrong', err));
}

function onReady(midi) {
  midi.addEventListener('statechange', (event) => initDevices(event.target));
  initDevices(midi);
}

function initDevices(midi) {
  // Reset.
 	midiIn = []
	midiOut = []

  const inputs = midi.inputs.values();
  for (let input = inputs.next(); input && !input.done; input = inputs.next()) {
    midiIn.push(input.value);
  }

  const outputs = midi.outputs.values();
  for (let output = outputs.next(); output && !output.done; output = outputs.next()) {
    midiOut.push(output.value);
  }

  if (midiOut.length > 0 && !selectedDeviceId) {
    selectedDeviceId = midiOut[0].id
  }

  startListening();
}

function startListening() {
  for (const input of midiIn) {
    input.addEventListener('midimessage', midiMessageReceived);;
  }
}

function midiMessageReceived(event) {
  if (receivedMessages.length >= 500) {
    receivedMessages.pop()
  }

  receivedMessages.unshift({
    timestamp: event.timeStamp,
    deviceName: event.target.name,
    deviceId: event.target.id,
    type: event.data[0] & 0xf0,
    channel: event.data[0] & 0x0f,
    id: event.data[1],
    value: event.data[2],
  })

  receivedMessages = receivedMessages
}

function midiMessageTypeToString(type) {
  switch (type) {
    case 0b1000_0000: return 'Note Off'
    case 0b1001_0000: return 'Note On'
    case 0b1010_0000: return 'Polyphonic Key Pressure'
    case 0b1011_0000: return 'Control Change'
    case 0b1100_0000: return 'Program Change'
    case 0b1101_0000: return 'Channel Pressure'
    case 0b1110_0000: return 'Pitch Bend'
    case 0b1111_0000: return 'System'
  }
  return 'Unknown'
}

function sendMidiMessage() {
  const device = midiOut.find((d) => d.id == selectedDeviceId);

  if (device) {
    const type = parseInt(selectedType, 2)
    const m = [(type & 0xF0) | (selectedChannel & 0x0F), selectedId]

    // program change and channel pressure only have two bytes, not three
    if (type !== 0b1100_0000 && type != 0b1101_0000) {
      m.push(selectedValue)
    }
    device.send(m);

    if (sentMessages.length >= 500) {
      sentMessages.pop()
    }
    sentMessages.unshift({
      timestamp: Date.now(),
      deviceName: device.name,
      deviceId: device.id,
      type: m[0] & 0xf0,
      channel: m[0] & 0x0f,
      id: m[1],
      value: m[2],
    })

    sentMessages = sentMessages
  }
}
</script>

<style>
:root {
  --color1: #70d6ff;
  --color2: #ff70a6;
  --color3: #ff9770;
  --color4: #ffd670;
  --color5: #e9ff70;
}

.wrap {
  margin: 0;
  height: 100%;
  width: 100%;
  background: var(--color1);
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 50% 50%;
}



.input {
  padding: 16px;
  background: var(--color2);
  overflow: hidden;
  padding-bottom: 0px;
  display: grid;
  grid-template-rows: 28px auto;
}

.input h2, .output h2, .noDevices {
  display: inline;
  text-transform: uppercase;
  font-size: 12px;
  color:black;
  opacity: 80%;
  font-weight: bold;
}

.noDevices {
  font-style: italic;
  opacity: 50%;
  color: black;
}

.input .devices .device, .output .devices .device {
  padding: 8px;
  background: var(--color1);
  border-radius: 8px;
  display: inline-block;
  margin-left: 8px;
  text-transform: uppercase;
  font-size: 12px;
  color: #000000CC;
  font-weight: bold;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.noReceivedMessages {
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
  padding: 32px;
  text-align: center;
  opacity: 50%;
  font-style: italic;
}


.messages {
  overflow-y: scroll;
  margin-top:16px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  padding-bottom: 32px;

  margin-left:-32px;
  margin-right:-32px;
  padding-left: 32px;
  padding-right: 32px
}
.messages::-webkit-scrollbar {
  width: 4px;
  height: 0;
  background-color: #0000; /* or add it to the track */

}
.messages::-webkit-scrollbar-thumb {
  background: #fff4;
  border-radius: 2px;
}
.messages::-webkit-scrollbar-corner {
  display: none;
}

.message {
  padding: 16px;
  background: var(--color5);
  border-radius: 4px;
  color: black;

  width: 152px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.message .device {
  display: block;
  text-align: right;
  opacity: 50%;
  text-transform: uppercase;
  font-size: 8px;
  font-weight: bold;
}
.message .value {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  opacity: 80%;
}
.message .type {
  display: block;
  text-align: center;
  margin-bottom: 8px;
  font-style:italic;
}


.value td {
  padding: 2px 0;
  padding-right: 8px;
}


.output {
  padding: 16px;
  background: var(--color4);
  overflow: hidden;
  padding-bottom: 0px;
  display: grid;
  grid-template-rows: 28px auto auto;
  align-content: start;
}

.messageBuilder {
  margin-top: 16px;
  padding: 16px;
  background: var(--color5);
  border-radius: 4px;
  color: black;

  width: 300px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.messageBuilder td {
  padding: 2px 0;
  padding-right: 8px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  opacity: 80%;
}

.messageBuilder input, .messageBuilder select {
  width: 156px;
}

.messageBuilder button {
  float: right;
}

.output .message {
  cursor: pointer;
}

</style>
<div class=wrap>
  <div class=input>
    <div class=devices>
      <h2>Inputs</h2>
      {#if midiIn.length === 0}
        <span class=noDevices>No MIDI input devices</span>
      {/if}
      {#each midiIn as device}
        <span class=device title="ID: {device.id}">{device.manufacturer} {device.name}</span>
      {/each}
    </div>
    {#if receivedMessages.length == 0}
      <p class=noReceivedMessages>Waiting for MIDI input...</p>
    {/if}
    <ul class=messages>
      {#each receivedMessages as m (m.timestamp)}
      <li class=message>
        <span class="value type">{midiMessageTypeToString(m.type)}</span>
        <table class=value>
          <tr>
            <td>Channel</td>
            <td>{m.channel}</td>
          </tr>
          <tr>
            <td>ID</td>
            <td>{m.id}</td>
          </tr>
          <tr>
            <td>Value</td>
            <td>{m.value !== undefined ? m.value : ''}</td>
          </tr>
        </table>
        <span class=device>{m.deviceName}</span>
      </li>
      {/each}
    </ul>
  </div>

  <div class=output>
    <div class=devices>
      <h2>Outputs</h2>
      {#if midiOut.length === 0}
        <span class=noDevices>No MIDI input devices</span>
      {/if}
      {#each midiOut as device}
        <span class=device title="ID: {device.id}">{device.manufacturer} {device.name}</span>
      {/each}
    </div>
    <div class=messageBuilder>
        <table>
          <tr>
            <td>Type</td>
            <td>
              <select bind:value={selectedType}>
                <option value="10000000">Note Off</option>
                <option value="10010000">Note On</option>
                <option value="10100000">Polyphonic Key Pressure</option>
                <option value="10110000">Control Change</option>
                <option value="11000000">Program Change</option>
                <option value="11010000">Channel Pressure</option>
                <option value="11100000">Pitch Bend</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Channel</td>
            <td><input type=number min=0 max=63 bind:value={selectedChannel}></td>
          </tr>
          <tr>
            <td>ID</td>
            <td><input type=number min=0 max=127 bind:value={selectedId}></td>
          </tr>
          <tr>
            <td>Value</td>
            <td><input disabled={selectedType === "11000000" || selectedType === "11010000"} type=number min=0 max=127 bind:value={selectedValue}></td>
          </tr>
          <tr>
            <td>Device</td>
            <td>
              <select bind:value={selectedDeviceId}>
                {#each midiOut as device}
                  <option value="{device.id}">{device.manufacturer} {device.name}</option>
                {/each}
              </select>
            </td>
          </tr>
        </table>
        <button on:click="{sendMidiMessage}">Send</button>
    </div>
    <ul class=messages>
      {#each sentMessages as m (m.timestamp)}
      <li class=message on:click="{() => {selectedType = m.type.toString(2); selectedChannel = m.channel; selectedId = m.id; selectedValue = m.value; selectedDeviceId = m.deviceId}}">
        <span class="value type">{midiMessageTypeToString(m.type)}</span>
        <table class=value>
          <tr>
            <td>Channel</td>
            <td>{m.channel}</td>
          </tr>
          <tr>
            <td>ID</td>
            <td>{m.id}</td>
          </tr>
          <tr>
            <td>Value</td>
            <td>{m.value !== undefined ? m.value : ''}</td>
          </tr>
        </table>
        <span class=device>{m.deviceName}</span>
      </li>
      {/each}
    </ul>
  </div>
</div>